/*
{
title: "Marte Sport Live",
description: "Marte Sport Live è una trasmissione sportiva, un talk con ospiti prestigiosi, opinionisti competenti, ex tecnici e giocatori di valore, giornalisti in carriera e protagonisti del calcio italiano e internazionale. Tutti i giorni, news, indiscrezioni, commenti con ampia interazione con i tifosi/ascoltatori.",
image: "https://www.radiomarte.it/marte/wp-content/uploads/2019/09/mspl200.png",
link: "http://www.radiomarte.it/marte/programmi/marte-sport-live/"
}
 */

export default function (data, props) {
    props.title = data.title;
    props.content = data.description;
    props.imageUrl = data.image;
}